// mock.js 用来mock数据
const Mock = require('mockjs')

/**
 * 使用Mock提供的api命名规则： xxx(api名称)_mock
 */

export function getSkuList_mock() {
  return [
    {
      skuId: 100000100, //商品id
      skuName: '140 Diamantes+Bônus de 14', //商品名称
      game: 'lordsmobile', //游戏名称
      country: 'br', //国家代码
      currency: 'R$', //货币代码
      currencyPrice: '20.00', //套餐价格，显示精度前端控制
      originalPrice: '24.00', //套餐原价，显示精度前端控制
      propsNum: '', //道具数量
      status: '', //商品状态
      desc: '', //描述信息
      create_time: +new Date(), //创建时间，秒级单位
      update_time: +new Date(), //更新时间，秒级单位
    },
    {
      skuId: 100000101, //商品id
      skuName: '2350 Diamantes+Bônus de 235', //商品名称
      game: 'lordsmobile', //游戏名称
      country: 'br', //国家代码
      currency: 'R$', //货币代码
      currencyPrice: '20.00', //套餐价格，显示精度前端控制
      originalPrice: '24.00', //套餐原价，显示精度前端控制
      propsNum: '', //道具数量
      status: '', //商品状态
      desc: '', //描述信息
      create_time: +new Date(), //创建时间，秒级单位
      update_time: +new Date(), //更新时间，秒级单位
    },
  ]
}

export function getChannelList_mock() {
  return [
    {
      game: 'lordsmobile',
      skuId: '100000100',
      channelId: '129',
      channel: 'PIX',
      subChannel: '',
      country: 'br',
      channelName: 'PIX',
      logo: '',
      company: '',
      low_price: '5',
      pay_price: '5',
      original_price: '5.8',
      desc: '',
      create_time: '',
      update_time: '',
      channel_promotion: '1',
      month_average_price: '',
    },
    {
      game: 'lordsmobile',
      skuId: '100000100',
      channelId: '101',
      channel: 'CreditCard',
      subChannel: '',
      country: 'br',
      channelName: 'Pagamento por Cartão',
      logo: '',
      company: '',
      low_price: '5',
      pay_price: '5',
      original_price: '5.8',
      desc: '',
      create_time: '',
      update_time: '',
      channel_promotion: '1',
      month_average_price: '',
    },
    {
      game: 'lordsmobile',
      skuId: '100000101',
      channelId: '101',
      channel: 'CreditCard',
      subChannel: '',
      country: 'br',
      channelName: 'Pagamento por Cartão',
      logo: '',
      company: '',
      low_price: '10',
      pay_price: '10',
      original_price: '11.9',
      desc: '',
      create_time: '',
      update_time: '',
      channel_promotion: '1',
      month_average_price: '',
    },
    {
      game: 'lordsmobile',
      skuId: '100000101',
      channelId: '118002',
      channel: 'Wallet',
      subChannel: '',
      country: 'br',
      channelName: 'Carteira D. PicPay',
      logo: '',
      company: '',
      low_price: '10',
      pay_price: '10',
      original_price: '11.9',
      desc: '',
      create_time: '',
      update_time: '',
      channel_promotion: '1',
      month_average_price: '',
    },
  ]
}

export function getSku2Channel_mock() {
  return Mock.mock({
    'data|8': [
      {
        'channelId|+1': 100000100, //通道id
        'skuId|+1': 100000100, //商品id
        channelPrice: '18.00', //优惠后价格
        'status|1': [0, 1], //0下架，1上架
        'order|+1': 1, //排序
        create_time: +new Date(), //创建时间，秒级单位
        update_time: +new Date(), //更新时间，秒级单位
      },
    ],
  })
}

export function queryOrderStatus_mock(orderNo) {
  return Mock.mock({
    object: {
      orderNo: orderNo, //订单号
      platformOrderNo: 'xxxxxx', //三方公司订单号
      orderStatus: 0, //订单状态
      awardStatus: 0, //发奖状态
    },
  })
}

export function queryOrderList_mock(game) {
  return Mock.mock({
    'data|8': [
      {
        'orderNo|+1': 100000100, //订单号
        'platformOrderNo|+1': 100000100, //三方公司订单号
        'skuId|+1': 100000100, //商品id
        skuName: 'package-1', //套餐名称
        game: game, //游戏名称
        'channelId|+1': 100000100, //通道id
        'channelName|1': ['PIX', 'Boleto', 'Carteira D. PicPay'], //通道名称
        'channel|1': ['PIX', 'Boleto', 'Carteira D. PicPay'], //渠道参数
        'subChannel|1': ['PIX', 'wellet'], //子渠道参数
        company: 'pagsmile', //支付公司
        source: 'xm-MVP', //业务类型
        payPrice: '20.00', //实际支付价格
        'orderStatus|1': [0, 1], //订单状态
        'awardStatus|1': [0, 1], //发奖状态
        create_time: +new Date(), //创建时间，秒级单位
        update_time: +new Date(), //更新时间，秒级单位
      },
    ],
  })
}

export function queryThemesStatus_mock() {
  return Mock.mock({
    'data|1': [
      {
        'type|1-2': 2, // 1-优惠券，2-礼品券
        couponGroup: 4567, // 券类别
        desc: '已领取', // 描述
        'couponStatus|0-2': 0, // 0-待领取，1-已领取，2-已使用
        'isExpired|1': true,
      },
    ],
  })
}

export function getTip_mock() {
  return new Promise((resolve) => {
    resolve()
  })
}

export function saveCoupon_mock() {
  return new Promise((resolve) => {
    resolve({})
  })
}

export function getCalculatePrice_mock() {
  return new Promise((resolve) => {
    resolve(
      Mock.mock({
        'discountMoney|1': [10, 100],
      })
    )
  })
}

export function getAvailableCoupon_mock() {
  return new Promise((resolve) => {
    resolve({
      discountMoney: 90,
      couponList: [],
      otherCouponList: [
        {
          id: 1,
          userCouponId: 1,
          money: 10,
          disabled: false,
          conditionGame: '',
          conditionOverlay: true,
          conditionPrice: 1000000000,
          conditionWares: '',
          country: '',
          couponDesc: '',
          couponDiscount: 10,
          couponMaxDeducePrice: 0,
          couponName: 'New customer New customer',
          couponNote: '',
          couponPrice: 100,
          couponStatus: 0,
          couponType: 1,
          createTime: 0,
          currency: 'Rp',
          receiveTime: 0,
          selected: false,
          timeActivate: 0,
          timeBegin: 0,
          timeEnd: 0,
          timeStop: 0,
          timeType: 1,
          updateTime: 0,
          timeEffective: '1637554090',
          timeAbolish: '1637554090',
          userCouponCreateTime: '1637554090',
          userCouponExpireTime: '1637554090',
        },
      ],
    })
  })
}

export function getPopus_mock() {
  return new Promise((resolve) => {
    resolve({
      activity: {
        activityDesc:
          '新客大礼包新客大礼包新客大sdfsdfsf礼包新客大礼包新客大礼包新客大礼包afsdfadsadaadf新客大礼包新客大礼包新客大礼包新客大sdfsdfsf礼包新客大礼包新客大礼包新客大礼包afsdfadsadaadf新客大礼包',
        activityId: 0,
        activityName: '新客大礼包新客大礼包新客大礼包',
        activityQuota: 0,
        activityStatus: 0,
        activityType: 0,
        country: '',
        createTime: 0,
        endTime: 0,
        everyUserUpperLimit: 0,
        extraInfo: '',
        game: '',
        promotionalProductId: 0,
        promotionalProductType: 0,
        sendQuota: 0,
        startTime: 0,
        updateTime: 0,
        userType: 0,
      },
      couponList: [
        {
          couponStatus: 1,
          couponType: 1,
          conditionPrice: 5.2,
          couponPrice: 11.2,
          currency: '$',
          timeType: 1,
          timeEffective: 1637554090,
          timeAbolish: 1637554090,
          couponDesc: '50 diamonds package available',
          conditionGame: 'freefire,pubg,lordsmobile',
          id: 2,
          circulation: 0,
          conditionOverlay: true,
          conditionWares: '',
          country: '',
          couponDiscount: 0,
          couponMaxDeducePrice: 0,
          couponName: '优惠券名称',
          couponNote: '',
          createTime: 0,
          receiveTime: 0,
          stock: 0,
          timeActivate: 0,
          timeBegin: 1637554090,
          timeEnd: 1637554090,
          timeStop: 0,
          updateTime: 0,
        },
        {
          couponStatus: 1,
          couponType: 1,
          conditionPrice: 5.2,
          couponPrice: 11.2,
          currency: '$',
          timeType: 1,
          timeEffective: 1637554090,
          timeAbolish: 1637554090,
          couponDesc: '50 diamonds package available',
          conditionGame: 'freefire,pubg,lordsmobile',
          id: 9,
          circulation: 0,
          conditionOverlay: true,
          conditionWares: '',
          country: '',
          couponDiscount: 0,
          couponMaxDeducePrice: 0,
          couponName: '优惠券名称',
          couponNote: '',
          createTime: 0,
          receiveTime: 0,
          stock: 0,
          timeActivate: 0,
          timeBegin: 1637554090,
          timeEnd: 1637554090,
          timeStop: 0,
          updateTime: 0,
        },
        {
          couponStatus: 1,
          couponType: 1,
          conditionPrice: 5.2,
          couponPrice: 11.2,
          currency: '$',
          timeType: 1,
          timeEffective: 1637554090,
          timeAbolish: 1637554090,
          couponDesc: '50 diamonds package available',
          conditionGame: 'freefire,pubg,lordsmobile',
          id: 19,
          circulation: 0,
          conditionOverlay: true,
          conditionWares: '',
          country: '',
          couponDiscount: 0,
          couponMaxDeducePrice: 0,
          couponName: '优惠券名称',
          couponNote: '',
          createTime: 0,
          receiveTime: 0,
          stock: 0,
          timeActivate: 0,
          timeBegin: 1637554090,
          timeEnd: 1637554090,
          timeStop: 0,
          updateTime: 0,
        },
        {
          couponStatus: 1,
          couponType: 1,
          conditionPrice: 5.2,
          couponPrice: 11.2,
          currency: '$',
          timeType: 1,
          timeEffective: 1637554090,
          timeAbolish: 1637554090,
          couponDesc: '50 diamonds package available',
          conditionGame: 'freefire,pubg,lordsmobile',
          id: 21,
          circulation: 0,
          conditionOverlay: true,
          conditionWares: '',
          country: '',
          couponDiscount: 0,
          couponMaxDeducePrice: 0,
          couponName: '优惠券名称',
          couponNote: '',
          createTime: 0,
          receiveTime: 0,
          stock: 0,
          timeActivate: 0,
          timeBegin: 1637554090,
          timeEnd: 1637554090,
          timeStop: 0,
          updateTime: 0,
        },
      ],
    })
  })
}

export function getMyCoupon_mock() {
  return new Promise((resolve) => {
    resolve([
      {
        couponStatus: 1,
        couponType: 1,
        conditionPrice: 5.2,
        couponPrice: 11.2,
        currency: '$',
        timeType: 1,
        timeEffective: '1637554090',
        timeAbolish: '1637554090',
        couponDesc: '50 diamonds + 50 diamonds package available',
        conditionGame: 'freefire,genshin,lordsmobile',
        id: 2,
        userCouponStatus: 1,
        userCouponId: 2,
        userCouponCreateTime: 1639659515870,
        userCouponExpireTime: 1639659515870,
      },
      {
        couponStatus: 2,
        couponType: 1,
        conditionPrice: 5.2,
        couponPrice: 11.2,
        currency: '$',
        timeType: 1,
        timeEffective: '1637554090',
        timeAbolish: '1637554090',
        couponDesc: '50 diamonds + 50 diamonds package available',
        conditionGame: 'freefire,pubgm,genshin,lordsmobile',
        id: 3,
        userCouponId: 3,
        userCouponStatus: 1,
      },
      {
        couponStatus: 3,
        couponType: 1,
        conditionPrice: 5.2,
        couponPrice: 11.2,
        currency: '$',
        timeType: 1,
        timeEffective: '1637554090',
        timeAbolish: '1637554090',
        couponDesc: '50 diamonds + 50 diamonds package available',
        conditionGame: 'genshin,moblielagens',
        id: 4,
        userCouponId: 4,
      },
      {
        couponStatus: 4,
        couponType: 1,
        conditionPrice: 5.2,
        couponPrice: 11.2,
        currency: '$',
        timeType: 1,
        timeEffective: '1637554090',
        timeAbolish: '1637554090',
        couponDesc: '50 diamonds + 50 diamonds package available',
        conditionGame: '',
        id: 1,
        userCouponId: 1,
      },
      {
        couponStatus: 5,
        couponType: 1,
        conditionPrice: 5.2,
        couponPrice: 11.2,
        currency: '$',
        timeType: 1,
        timeEffective: '1637554090',
        timeAbolish: '1637554090',
        couponDesc: '50 diamonds + 50 diamonds package available',
        conditionGame: 'freefire,lordsmobile',
        id: 5,
        userCouponId: 5,
      },
    ])
  })
}

let month = 12
export function transactionData_mock(pageNo, pageSize) {
  month--
  return {
    pageNo: pageNo,
    pageSize: pageSize,
    total: 50,
    detailMonths: [
      {
        accountDetails: [
          {
            amount: 45,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1639292300039',
            tradeType: 1,
          },
          {
            amount: 90,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1638756690000',
            tradeType: 1,
          },
          {
            amount: 200,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1638590430000',
            tradeType: 1,
          },
          {
            amount: 400,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1638316800000',
            tradeType: 2, // 消费
            gameName: 'freefire',
            logo: require(`@/assets/images/order/pic-freefire.png`),
            skuName: 'fdsfsadfasdgsgsdf',
            id: 1,
          },
        ],
        month: month,
        year: 2021,
      },
      {
        accountDetails: [
          {
            amount: 345,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1637208513000',
            tradeType: 1,
          },
          {
            amount: 400,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1636547157000',
            tradeType: 1,
          },
          {
            amount: 345,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1637208513000',
            tradeType: 1,
          },
          {
            amount: 400,
            partnerAccountInfo: '',
            skuId: '',
            tradeTime: '1636547157000',
            tradeType: 1,
          },
        ],
        month: month - 1,
        year: 2021,
      },
    ],
  }
}
function dataToPromise(data) {
  return new Promise((resolve) => {
    resolve(data)
  })
}

export function verifyPayPassword_mock() {
  return dataToPromise(
    Mock.mock({
      'result|0-2': 0, // 校验结果 0未设置 1已设置-校验成功 2已设置-校验失败
    })
  )
}

export function getAccountAmount_mock() {
  return dataToPromise(
    Mock.mock({
      amount: Mock.Random.integer(-5, 5),
    })
  )
}

export function success_mock() {
  return dataToPromise(
    Mock.mock({
      result: true,
    })
  )
}

let count = 1
export function pwSet_mock() {
  if (count === 1) {
    count++
    return dataToPromise(
      Mock.mock({
        result: false,
      })
    )
  } else {
    // console.log(`第${count}次请求 checkPasswordIsSet `, true)
    return dataToPromise(
      Mock.mock({
        result: true,
      })
    )
  }
}
